import React, { useState, useEffect } from "react";
import axios from 'axios';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import { IconButton, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import PrimaryButton from './PrimaryButton';
import Grid from "@material-ui/core/Grid";
import CloseIcon from "./../icons/CloseIcon";
import DocIcon from "./../icons/DocIcon";
import AddedIcon from "./../icons/AddedIcon";
import Typography from "@material-ui/core/Typography";
import CustomInput from './CustomInput';
import CustomSelect from './CustomSelect';
import DropZone from './dropzone/DropZone';
import translate from './../other/translate.json';
import config from './../other/config';
import utils from '../other/utils';
const { serverAPI } = config;

const questions = [{ "name": "question1", "header": "Оцените наполнение сайта полезной для вас информацией", "data": [{ "id": 5, "name": "Вся информация полезная" }, { "id": 4, "name": "Информация частично полезная" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Много лишней информации" }, { "id": 1, "name": "Нужна другая информация" }] }, { "name": "question2", "header": "В какой степени тексты с описанием приложений/продуктов/готовых решений для вас понятны?", "data": [{ "id": 5, "name": "Полностью понятны" }, { "id": 4, "name": "Понятны" }, { "id": 3, "name": "Скорее понятны" }, { "id": 2, "name": "Скорее непонятны" }, { "id": 1, "name": "Непонятны" }] }, { "name": "question3", "header": "Насколько вам просто ориентироваться на сайте с Каталогами?", "data": [{ "id": 5, "name": "Очень просто" }, { "id": 4, "name": "Скорее просто" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Скорее сложно" }, { "id": 1, "name": "Очень сложно" }] }, { "name": "question4", "header": "Насколько вам просто найти на сайте нужную информацию?", "data": [{ "id": 5, "name": "Очень просто" }, { "id": 4, "name": "Скорее просто" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Скорее сложно" }, { "id": 1, "name": "Очень сложно" }] }, { "name": "question5", "header": "Как вы оцениваете внешний вид, дизайн сайта?", "data": [{ "id": 5, "name": "Очень хороший" }, { "id": 4, "name": "Хороший" }, { "id": 3, "name": "Нормальный" }, { "id": 2, "name": "Плохой" }, { "id": 1, "name": "Мне он совсем не нравится" }] }, { "name": "question6", "header": "Как быстро у вас загружаются страницы сайта?", "data": [{ "id": 5, "name": "Очень быстро" }, { "id": 4, "name": "Быстро" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Долго" }, { "id": 1, "name": "Очень долго" }] }, { "name": "question7", "header": "Удобный ли поиск информации по сайту?", "data": [{ "id": 5, "name": "Очень удобный" }, { "id": 4, "name": "Удобный" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Не удобный" }, { "id": 1, "name": "Не знаю о такой возможности" }] }, { "name": "question8", "header": "Удобно ли вам пользоваться корзиной для комплектации приложений?", "data": [{ "id": 5, "name": "Да, очень удобно" }, { "id": 4, "name": "Удобно" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Нет, не удобно" }, { "id": 1, "name": "Совсем не удобно" }] }, { "name": "question9", "header": " Насколько сложно, по вашему мнению, скачивание файлов с сайта?", "data": [{ "id": 5, "name": "Очень просто" }, { "id": 4, "name": "Скорее просто" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Скорее сложно" }, { "id": 1, "name": "Не знаю о такой возможности" }] }, { "name": "question10", "header": " Насколько для вас просто найти на сайте контактную информацию для отправки вопросов специалистам ЦФТ?", "data": [{ "id": 5, "name": "Очень просто" }, { "id": 4, "name": "Просто" }, { "id": 3, "name": "Нормально" }, { "id": 2, "name": "Сложно" }, { "id": 1, "name": "Не знаю о такой возможности" }] }, { "name": "question11", "header": " Насколько вы в общем довольны сайтом?", "data": [{ "id": 5, "name": "Очень доволен/льна" }, { "id": 4, "name": "Доволен/льна" }, { "id": 3, "name": "Скорее недоволен/льна" }, { "id": 2, "name": "Недоволен/льна" }, { "id": 1, "name": "Очень недоволен/льна" }] }, { "name": "question12", "header": " Вы бы рекомендовали сайт коллегам?", "data": [{ "id": 5, "name": "Несомненно да" }, { "id": 4, "name": "Вероятно да" }, { "id": 3, "name": "Не знаю" }, { "id": 2, "name": "Вероятно нет" }, { "id": 1, "name": "Несомненно нет" }] }]

export default function BasketAskCFT(props) {
  const { isAuth, usname, showInterview, _showInterview } = props;
  let lang = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  // const [state, setState] = React.useState(false);
  const [fio, setFio] = useState('');
  const [bank, setBank] = useState('');
  const [position, setPosition] = useState('');
  const [mobile, setMobile] = useState('');
  const [mail, setMail] = useState('');
  const [letter, setLetter] = useState('');
  const [answer, setAnswer] = useState('');
  const [answers, _answers] = useState({});

  const q2Vars = [{ id: 5, name: "5.Вся информация полезная" }, { id: 4, name: "Информация частично полезная" }, { id: 3, name: "Нормально" }, { id: 4, name: "2. Много лишней информации" }, { id: 4, name: "1. Нужна другая информация" }];

  useEffect(() => {
    // if (props.isAuth == true) {
    let didCancel = false;
    const fetchData = async () => {

      if (!didCancel && isAuth) {

        const draft = await axios.get(`${serverAPI}/getDrafts`);

        if (draft && draft.data && draft.data.error === undefined) {
          let { sender, senderbank, senderposition, senderphone, sendermail, letter, answers } = draft.data;
          setFio(sender)
          setBank(senderbank)
          setPosition(senderposition)
          setMobile(senderphone)
          setMail(sendermail)
          setLetter(letter)
          _answers(answers === "" ? {} : answers)

        } else if (isAuth && usname && usname.usname) {
          if (fio === '') {
            setFio(usname.usname || '')
          }
          if (bank === '') {
            setBank(usname.organization || '')
          }
          if (position === '') {
            setPosition(usname.title || '')
          }
          if (mobile === '') {
            setMobile(usname.phone || '')
          }
          if (mail === '') {
            setMail(usname.email || '')
          }
        }
      }
      //setTimeout(callSaveDraft, 2*1000)
    }

    fetchData();

    return () => {
      didCancel = true;
    };
    // }
  }, [isAuth]);

  useEffect(() => {
    // if (props.isAuth == true) {
    let didCancel = false;
    const fetchData = async () => {
      if (!didCancel) {
        saveDraft()
      }
    }
    fetchData();
    return () => {
      didCancel = true;
    };
    // }
  }, [answers]);

  const callSaveDraft = () => {
    saveDraft();
    setTimeout(callSaveDraft, 10 * 1000)
  }
  const saveDraft = async () => {
    // const { hasProperty } = utils
    // console.log(fio, answers)
    // let sender = fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? fio.trim() : '';
    // let senderbank = bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? bank.trim() : ''
    // let senderposition = position.trim()
    // let senderphone = mobile.trim()
    // let sendermail = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? mail.trim() : '';
    // console.log(sender, senderbank, senderposition, senderphone, sendermail, letter, answers)
    // if (hasProperty(sender) && hasProperty(senderbank)) {
    //   const sendAnswers_res = await axios.post(`${serverAPI}/saveDrafts`,
    //     { sender, senderbank, senderposition, senderphone, sendermail, letter, answers }
    //   );
    // }

  }


  function toggleDrawer(open, event) {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    // setState(open);
  };

  function closeDrawer() {
    _showInterview(false)
    setAnswer('')
    try {
      localStorage.removeItem('showInterview')
    } catch (e) {

    }
  }

  function cutFioValue(value) {
    const shouldSetValue = value.length < 256
    if (shouldSetValue) setFio(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  function cutMailValue(value) {
    const shouldSetValue = value.length < 255

    if (shouldSetValue) setMail(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  function cutBankValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setBank(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  function cutPositionValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setPosition(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  function cutMobileValue(value) {
    const shouldSetValue = value.length < 51

    if (shouldSetValue) setMobile(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  function cutLetterValue(value) {
    const shouldSetValue = value.length < 256

    if (shouldSetValue) setLetter(value.replace(/ +/g, ' ').replace(/'/g, '"'))
  }

  async function sendAnswers() {
    let sender = fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? fio.trim() : 'Не авторизованный пользователь';
    let senderbank = bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? bank.trim() : ''
    let senderposition = position.trim()
    let senderphone = mobile.trim()
    let sendermail = mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? mail.trim() : '';

    //if (sender !== '' && senderbank !== '' && sendermail !== '') {
      const sendAnswers_res = await axios.post(`${serverAPI}/sendAnswers`,
        { sender, senderbank, senderposition, senderphone, sendermail, letter, answers, IdInterview: '2026_1' }
      );
      try {
        localStorage.removeItem('showInterview')
      } catch (e) {

      }
      // closeDrawer()
      setAnswer(sendAnswers_res.data.result)
    //}
  }

  const CustomRadio = withStyles({
    root: {
      color: '#F6F6FB',
      '&$checked': {
        color: '#EB505E',
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  function RadioForm(props) {
    const { name, header, value, onChange, data } = props
    const classes = useStyles()
    return (
      <FormControl component="fieldset" style={{ marginTop: 17 }} >
        <Typography className={classes.header}
        // style={{ lineHeight: '44px' }}
        >
          <div>{header} </div>
        </Typography>
        <RadioGroup aria-label="g" name={name} value={value} onChange={onChange}>
          {data.map(el => {
            return (
              <FormControlLabel style={{ color: '#8987A2' }} value={el.id} control={<CustomRadio />} label={el.name} />
            )
          })}

        </RadioGroup>
      </FormControl>
    )
  }


  function hasAllQuestion() {
    //console.log("answer q1",!!answer['q1'] && answer['q1'] !== '')
    // let condition = true;
    // questions.map(el => el.name).map(el => {
    //   if (answers[el] === undefined) {
    //     condition = false;
    //   }
    // })
    // return condition
    return !!answers['q1'] && answers['q1'] !== '' && !!answers['q2'] && !!answers['q3'] && !!answers['q4'] && !!answers['q5']// && !!answers['q6'] && answers['q6'] !== ''
  }

  const radioVariants = [{"id": 1, "name": "Да"},{"id": 2, "name": "Нет"},{"id": 3, "name": "Не знаю"} ]

  function list(anchor) {
    return (
      <div
        className={classes.list}
        role="presentation"
        onClick={() => toggleDrawer(anchor, false)}
        onKeyDown={() => toggleDrawer(anchor, false)}
        style={{ overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}
      >
        <Grid
          container
          direction="column"
          justify="flex-start"
          className={classes.root}
        >
          <Grid item container>
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 14 }}>
              <Typography className={classes.listHeader}>Реализация в дистрибутиве ЦФТ-Банк функциональности <a style={{color:'#8987A2'}} href="https://catalog.cft.ru/applications/cftbank/applist?filt=false&direction=253">по подготовке сведений в рамках проведения проверок кредитных организаций </a>  </Typography>
            </Grid>
          </Grid>

          <Grid item container direction="column" style={{ marginTop: 29 }}>
            <Grid item>
              <form className={classes.rootForm} noValidate>
                <Grid container direction="column">

                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>   Уважаемые клиенты! <br/>
                      Просим пройти короткий опрос в срок <strong>до 16 октября:</strong></Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.header} style={{ lineHeight: '44px', marginTop:16 }}>   Укажите ваш e-mail</Typography>
                  </Grid>

                  <Grid item>
                    <CustomInput
                      //value={letter}
                      onChange={(e) => {let value = e.target.value;  _answers(prevState => { return { ...prevState, "q1": value.replace(/'|"/gmi,'') } })}}
                      className={classes.margin}
                    // label={translate.Discuss[`TypeYourTextHere${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>Предоставляет или планирует ли ваш банк предоставлять в ближайшее время учетно-операционную и иную информацию, запрашиваемую на основании Инструкции Банка России от 15.01.2020 № 202-И  (<a href="https://cbr.ru/development/tech_r" style={{color:'#8987A2'}} >Состав и форматы информации, запрашиваемой в ходе проведения проверок поднадзорных лиц</a>)?</Typography>
                  </Grid>

                  <Grid  item>
                    <RadioForm name={"q2"} header={null} data={radioVariants} value={answers["q2"]} onChange={(event) => {
                      let { value } = event.target;
                      _answers(prevState => { return { ...prevState, "q2": +value } })

                    }} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>Заинтересован ли ваш банк в получении комплексных услуг по подготовке к проведению проверок Банком России?</Typography>
                  </Grid>

                  <Grid  item>
                    <RadioForm name={"q3"} header={null} data={radioVariants} value={answers["q3"]} onChange={(event) => {
                      let { value } = event.target;
                      _answers(prevState => { return { ...prevState, "q3": +value } })

                    }} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>Заинтересован ли ваш банк в дистрибутивной реализации функциональности формирования в электронном виде учетно-операционной и иной информации, запрашиваемой на основании Инструкции Банка России от 15.01.2020 № 202-И (<a href="https://cbr.ru/development/tech_r" style={{color:'#8987A2'}} >Состав и форматы информации, запрашиваемой в ходе проведения проверок поднадзорных лиц</a>)</Typography>
                  </Grid>

                  <Grid  item>
                    <RadioForm name={"q4"} header={null} data={radioVariants} value={answers["q4"]} onChange={(event) => {
                      let { value } = event.target;
                      _answers(prevState => { return { ...prevState, "q4": +value } })

                    }} />
                  </Grid>
                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>Используете ли альтернативные способы формирования в электронном виде учетно-операционной и иную информации, запрашиваемой на основании Инструкции Банка России от 15.01.2020 № 202-И (<a href="https://cbr.ru/development/tech_r" style={{color:'#8987A2'}} >Состав и форматы информации, запрашиваемой в ходе проведения проверок поднадзорных лиц</a>)?</Typography>
                  </Grid>

                  <Grid  item>
                    <RadioForm name={"q5"} header={null} data={radioVariants} value={answers["q5"]} onChange={(event) => {
                      let { value } = event.target;
                      _answers(prevState => { return { ...prevState, "q5": +value } })

                    }} />
                  </Grid>

                  <Grid item>
                    <Typography className={classes.header} /*style={{ lineHeight: '44px' }}*/>   Если используете альтернативные способы формирования, можете указать какие?</Typography>
                  </Grid>

                  <Grid item>
                    <CustomInput
                      //value={letter}
                      onChange={(e) => {let value = e.target.value;  _answers(prevState => { return { ...prevState, "q6": value.replace(/'|"/gmi,'') } })}}
                      className={classes.margin}
                    // label={translate.Discuss[`TypeYourTextHere${lang}`]}
                    />
                  </Grid>



                  {/* {questions.map((el, i) => {
                    return (
                      <Grid key={i} item>
                        <RadioForm name={el.name} header={el.header} data={el.data} value={answers[el.name]} onChange={(event) => {
                          let { value } = event.target;
                          _answers(prevState => { return { ...prevState, [el.name]: +value } })

                        }} />
                      </Grid>
                    )
                  })} */}
                  {/* <Grid item>
                    <CustomInput
                      error={fio === undefined || fio.trim() === '' || fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? false : true}
                      valid={fio === undefined || fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? true : false}
                      helperText={fio === undefined || fio === '' ? translate.Discuss[`MandatoryField${lang}`] : fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={fio || ''}
                      onChange={(e) => cutFioValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`LetterFullNamen_${lang}`]}
                      hint={true}


                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      error={mail.trim() === '' || mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? false : true}
                      valid={mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false}
                      helperText={mail === '' ? translate.Discuss[`MandatoryField${lang}`] : mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectEmail${lang}`]}
                      value={mail}
                      onChange={(e) => cutMailValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Email${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      error={bank.trim() === '' || bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? false : true}
                      valid={bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? true : false}
                      helperText={bank === '' ? translate.Discuss[`MandatoryField${lang}`] : bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/) ? translate.Discuss[`MandatoryField${lang}`] : translate.Discuss[`EnterTheCorrectData${lang}`]}
                      value={bank}
                      onChange={(e) => cutBankValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Company${lang}`]}
                      hint={true}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      value={position}
                      onChange={(e) => cutPositionValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`Position${lang}`]}
                    />
                  </Grid>

                  <Grid item>
                    <CustomInput
                      value={mobile}
                      onChange={(e) => cutMobileValue(e.target.value)}
                      className={classes.margin}
                      label={translate.Discuss[`ContactPhone${lang}`]}
                    />
                  </Grid> */}

                </Grid>
              </form>
            </Grid>

            <Grid item container direction="row" alignItems="center" className={classes.ActionArea}>
              <Grid item>
                <PrimaryButton
                  disabled={
                    // (fio !== undefined && fio.trim() !== '' && fio.match(/^[A-Za-zА-ЯЁа-яё\ \- \' \`]+$/))
                    //   &&
                    //   (mail.trim() !== '' && mail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i))
                    //   &&
                    //   (bank.trim() !== '' && bank.match(/^[A-Za-zА-ЯЁа-яё0-9\ \- \' \` \" \& \%]+$/))
                    //   &&
                      hasAllQuestion()
                      ?
                      false
                      :
                      true
                  }
                  height={55}
                  text={translate.Discuss[`Send_${lang}`]}
                  onClick={() => sendAnswers()}
                />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>

            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  function listSubmitTrue() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#81D39D', borderRadius: '50%', boxShadow: 'none' }}
              >
                <AddedIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>Спасибо за обратную связь !</Typography>
              {/* <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>{translate.Discuss[`Successfully${lang}`]}</Typography> */}
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => /*closeDrawer()*/window.location.href = "/"} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>)
  };

  function listSubmitFalse() {
    return (
      <div
        className={classes.list}
        role="presentation"
      >
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.root}
          style={{ padding: 64, paddingTop: 254 }}
        >
          <Grid item container direction="column" justify="center" alignItems="center">
            <Grid className={classes.btnClose}>
              <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
                <CloseIcon fill='#BCBBD0' />
              </IconButton>
            </Grid>

            <Grid item>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ width: 72, height: 72, backgroundColor: '#BCBBD0', borderRadius: '50%', boxShadow: 'none' }}
              >
                <CloseIcon fill={'#FFFFFF'} />
              </Grid>
            </Grid>

            <Grid item style={{ marginTop: 30 }}>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>По техническим причинам</Typography>
              <Typography className={classes.listHeader} style={{ textAlign: 'center' }}>сервис временно недоступен.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 24 }}>
              <Typography className={classes.Body1}>Попробуйте повторно позднее.</Typography>
            </Grid>

            <Grid item style={{ marginTop: 40 }}>
              <PrimaryButton onClick={() => closeDrawer()} height={55} text={'Закрыть'} />
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  };

  return (
    <div>
      <React.Fragment key="anchor">
        <Grid container direction="row"
          // anchor={"right"}
          // open={true/*showInterview*/}
          // onClose={() => closeDrawer()}
        >
          {/* <Grid className={classes.btnClose}>
            <IconButton onClick={() => closeDrawer()} aria-label="filter" className={classes.btnFilter}>
              <CloseIcon fill='#BCBBD0' />
            </IconButton>
          </Grid> */}


          <React.Fragment>
            {
              answer === 1
                ?
                listSubmitTrue('right')
                :
                answer === 0
                  ?
                  listSubmitFalse('right')
                  :
                  list()
            }
          </React.Fragment>


        </Grid>
      </React.Fragment>
    </div>
  );

}

const useStyles = makeStyles(theme => ({
  root: {
    padding: 64,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },
  },

  list: {
    width: '100%',
    backgroundColor:'#fff',

    [theme.breakpoints.down(696)]: {
      width: '100%',
    },
  },

  fullList: {
    width: 'auto',
  },

  listHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: "#24262A"
  },

  btnClose: {
    position: 'absolute',
    right: 12,
    top: 12,
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Info1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#BCBBD0'
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
  },

  LinkType11: {
    color: 'inherit',
    textDecoration: 'none',
    borderBottom: '1px solid',
    borderColor: 'inherit',

    '&:hover': {
      color: '#2050FF',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  },

  ActionArea: {
    marginTop: 0,
    justifyContent: "space-between",
    marginTop: 11,
    maxWidth: 472,
  }
}));